<template>
    <transition name="el-fade-in">
        <div class="all" v-show="show">
            <div class="title">{{ name || "Daily Image" }}</div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item
                    :to="{ path: '/dailyimage-list' }"
                    >image list</el-breadcrumb-item
                >
                <el-breadcrumb-item>{{
                    name || "change image"
                }}</el-breadcrumb-item>
            </el-breadcrumb>
            <page-editer
                ref="editer-dailyimage"
                :modelData.sync="data"
                :render="renderData"
                :handlerSave="Save"
                :handlerDelete="Delete"
                :handleLoad="Loaded"
            ></page-editer>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            name: "",
            show: false,
            renderData: [
                {
                    key: "image",
                    type: "image",
                    modelName: "imageUrl",
                    must: true,
                    // limit:[360,360,'==']
                },
                {
                    key: "Cover Image",
                    type: "image",
                    modelName: "coverImageUrl",
                    must: true,
                    // limit:[360,360,'==']
                },
                {
                    key: "bgColor",
                    type: "colorPicker",
                    modelName: "bgColor",
                    noAlpha:true
                },
            ],
            data: {
                name: "",
                description: "",
            },
        };
    },
    methods: {
        Save() {
            let uploadData = this.$deepCopy(this.data);
            this.renderData.some((item) => {
                // 多选数组转字符串数组
                if (item.type === "selects" && this.data[item.modelName]) {
                    uploadData[item.modelName] = this.data[item.modelName].toString();
                }
            });
            this.$request("/manage/onboardImg/save", uploadData, (res) => {
                if (res.data.code === 200) {
                    this.$message({
                        message: "save success",
                        type: "success",
                    });
                    this.$router.push('/dailyimage-list');
                }
            });
        },
        Delete() {
            this.$confirm("Confirm delete？", "", { type: "warning" }).then(() => {
                this.$request(
                    `/manage/onboardImg/del/${this.$route.query.id}`,
                    {},
                    (res) => {
                        if (res.data.code === 200) {
                            this.$message({
                                message: "delete success",
                                type: "success",
                            });
                            this.$router.go(-1);
                        }
                    }
                );
            });
        },
        getOrder() {
            // let Array = [],
            //     Array2 = [];
            // let lableDoms = this.$refs.transfer.$el
            //     .querySelectorAll(".el-checkbox-group")[1]
            //     .querySelectorAll(".el-checkbox__label");
            // for (let i = 0; i < lableDoms.length; i++) {
            //     Array.push(lableDoms[i].querySelector("span").innerText);
            // }
            // Array.some((item2) => {
            //     this.transferBase.some((item) => {
            //         if (item2 === item.exerciseName) {
            //             Array2.push(item);
            //         }
            //     });
            // });
            // this.trueOrder = Array2;
            1;
        },
        Loaded() {
            this.show = true;
            if (this.$route.query.id && this.$route.query.id != "add") {
                this.$request(
                    `/manage/onboardImg/detail/${this.$route.query.id}`,
                    {},
                    (res) => {
                        let data = res.data.data;
                        this.renderData.some((item) => {
                            if (item.type === "selects" && data[item.modelName]) {
                                data[item.modelName] = data[item.modelName].split(",");
                            }
                        });
                        this.data = data;
                    },
                    "get",
                    true
                );
            }
        },
    },
};
</script>

<style scoped>
.all {
    box-sizing: border-box;
    padding: 0 40px;
    text-align: left;
    font-size: 13px;
    margin-top: 30px;
}
.title {
    font-size: 24px;
    line-height: 50px;
}
.el-breadcrumb {
    height: 20px;
    line-height: 20px;
    margin-top: 30px;
}
/* .kuai-con .el-input >>> input
{
    font-size: 13px;
    height: 27px;
} */
</style>